import { Component, OnInit, TemplateRef, ChangeDetectorRef } from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ImageUrls } from "src/app/services/s3buket";
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import * as CONSTANT from "../../services/constants";

import { DomSanitizer } from "@angular/platform-browser";
import { saveAs } from "file-saver/dist/FileSaver"; 
import { Lightbox } from "ngx-lightbox";
@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"]
})
export class ProfileComponent implements OnInit {
  modalRef?: BsModalRef;
  userData:any;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users
  globalTemplateUrl = ImageUrls.BaseUrl + ImageUrls.directories.comman
  profileImage:any;
  resumeData:any;
  // form basic info
  form:FormGroup;
  showError : boolean = false;
  // vatern
  formVeteran:FormGroup;
  fileUploadV;
  serviceList:any=[];
  fileName: any;
  haveFileName: any;
	vetFileUpload;
  vetFileName: any;
  haveVeternFileName: any;
  isAccept: boolean =false;
  fileSize: boolean =false;
  // skillList
  skillform:FormGroup;
  show = true;
  skillList:any=[];  
  allSkills:any=[];  
  userSkill: string = "";
  userSkillUpdate = new Subject<string>();
  addedSkills:any=[];
  // datepicker
  minDate = new Date();
	maxDate = new Date();
	today: Date | undefined;
  title="Add";
  datePipe: any;
  // work-exp
  startDate =  new Date();
  endDate =  new Date();
  workForm: FormGroup;
  allCompany:any=[];
  allJob:any=[];
  // edit edu
  eduForm: FormGroup;
  allEducationList:any=[];
  showGPAError = false;
  showOtherDegree : boolean = false;
  showLinkSameError : boolean = false;
  showOtherUniversity : boolean = false;
  // uni&spec
  allSpec:any=[];
  allUni:any=[];
  // vol
  volForm: FormGroup;
  allEmployee:any=[];
  //projects
  projectForm:FormGroup;
  addTeam:FormGroup; 
  memberEditingPosition=-1;
  showTeamMemberError:boolean=false;
  awardList:any=[]; 
  fileUpload;
  thumbnailImage:any=[];
  //awardform
  awardform:FormGroup;
  //lic
  licForm:FormGroup; 
  editId=""
  //langugae
  Languages:any=CONSTANT.Languages;
  langForm:FormGroup;
  showErrorSameLanguage: boolean =false;
  //jobForm
  jobForm:FormGroup;
  addTour: FormGroup;
  addJob: FormGroup;
  
  allIndustry:any=[];
  allJobtitle:any=[];
  allTravel:any=[];
  allSecurity:any=[];
  allJobs:any;
  allJobPreference:any=[];
  allTourOfDuties:any=[];
  // add prefer-locatim
  showLocationError =false;
  showLocError =false;
  tourEditingPosition = -1;
  locationEditingPosition = -1;
  
  // industry search 
  addedIndus:any=[]
  userIndus: string = ""; 
  userIndusUpdate = new Subject<string>();
  showIndus = false;
  // job search
  jobQues: string = "";
  jobQuesUpdate = new Subject<string>();
  addedJobs:any=[]
  showJob = false;
  //  download
  sampleList:any=[];
  downloadForm: FormGroup;
  showTemplateError: boolean =false;
  // other click
  showOtherService: boolean =false;
  showContract: boolean= false;
  // lightgallery
  _albums: any = [];
  mediaInfo = [];
  // get sub-category
  categoryId:any;
  allCat:any=[];
  allSubCat:any=[];
  subCat:boolean=false;
  showErrorToAdd:boolean=false;
  dropdownSettings:any;
  dropdownLanguageSettings:any;
  currentDate: any;
  dropdownSettingJobTitle:any;
  dropdownSettingsIndustry:any;
  selectedIndustriesDetails: any =[];
  selectedJobTitleDetails: any =[];
  
  // mos list
  allMosCode: any = [];
  dropdownSettingsMilitary:any;
  selectedServiceId:any;
  workPlaceList:any=[{name:'Remote',selected:false},{name:'Onsite',selected:false},{name:'Hybrid',selected:false}]
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private http: HttpClient, private handler: HttpBackend, private sanitizer: DomSanitizer, private _lightbox: Lightbox, private _lightboxGallery: Lightbox, private cdf:ChangeDetectorRef) {
    this.form = this.formBuilder.group({
      phoneNumber: ["", Validators.compose([Validators.required])],
      countryCode: ["+1"],
      scoreLink:  ["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEX)])],
      location: ["", Validators.compose([Validators.required])],
    });
    this.formVeteran = this.formBuilder.group({
      serviceId: ["", Validators.compose([Validators.required])],
      otherServiceTitle: [""],
      militaryTitle: ["", Validators.compose([Validators.required])],
      militaryJobTitleId: [""],
      militaryJobTitle: [""],
      authenticityDocumentLink: [""],
      veteranRelationDocumentLink: [""],
      veteranRelationName: [""],
      userType: [""], 
    });
    this.skillform = this.formBuilder.group({
      skillIdsArray: ["", Validators.compose([Validators.required])],
    });
    
    this.workForm = this.formBuilder.group({
      id: [""],
      employementTypeId: [""],
      jobTitle: ["", Validators.compose([Validators.required,Validators.maxLength(50)])],
      companyName: ["", Validators.compose([Validators.required,Validators.maxLength(50)])],
      underContractOf: [""],
      fromDate: [""],
      toDate: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
      location: [""],
      isCurrentlyRole: [""],
    });
    this.eduForm = this.formBuilder.group({
      id: [""],
      specializationId: ["", Validators.compose([Validators.required])],
      otherTitleSpecialization: [""],
      universityId: ["", Validators.compose([Validators.required])],
      otherTitleUniveristy: [""],
      fromDate: [""],
      toDate: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
      gpa: [""],
      isPursuing: [""],
    });
    this.volForm = this.formBuilder.group({
      id: [""],
      employementTypeId: [""],
      organization: ["", Validators.compose([Validators.required])],
      fromDate: [""],
      toDate: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
      role: ["", Validators.compose([Validators.required])],
      cause: [""],
      isCurrentlyRole: [""],
    });
    this.projectForm = this.formBuilder.group({
      id: [""],
      associatedWith: [""],
      projectTitle: ["", Validators.compose([Validators.required,Validators.maxLength(50)])],
      location: [""],
      fromDate: [""],
      toDate: [""],
      isCurrentlyOngoing: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
      projectMembers:[""],
      projectLinksTypeOf:["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEX)])],
      projectLinks:[""],
      projectMedia:[""],
    });
    this.addTeam = this.formBuilder.group({
      name:["", Validators.compose([Validators.required])],
      email:["", Validators.compose([Validators.required,Validators.pattern(CONSTANT.EMAIL_REGEX)])],
    })
    this.licForm = this.formBuilder.group({
      id: [""],
      name: ["", Validators.compose([Validators.required])],
      attestedByAuthority: ["", Validators.compose([Validators.required])],
      credentialUrl: ["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEX)])],
      certificationNo: [""],
      issuesedOn: [""],
      expirydate: [""],
    });
    this.langForm = formBuilder.group({
      id:[""],
      language: ["", Validators.compose([Validators.required])],
      proficiency: ["", Validators.compose([Validators.required])],
    })
    this.awardform = this.formBuilder.group({
      id: [""],
      name: ["", Validators.compose([Validators.required])],
      issuer: [""],
      issuesedOn: [""],
      associatedWith: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
    });
    this.jobForm = this.formBuilder.group({
      // id: [""],
      // industrySearch: [""],
      // jobTitleSearch: [""],
      industryIds: ["", Validators.compose([Validators.required])],
      categoryId: ["", Validators.compose([Validators.required])],
      subCategoryId: [""],
      jobTitleIds: ["", Validators.compose([Validators.required])],
      employementTypeId: [""],
      employementType: [""],
      desiredSalary: [""],
      desiredSalaryType: [""],
      workPlace: [""],
      securityClearance: [""],
      serviceId: [""],
      otherServiceTitle: [""],
      travelRequirement: [""],
      willingToRelocate: [""],
      covidVaccinated: [""],
      locations: ["", Validators.compose([Validators.required])],
      tourOfDuties: [""],
      dateOfAvailability: [""],
      workAuthorization: ["", Validators.compose([Validators.required])],
    }); 
    this.addTour =this.formBuilder.group({
      location:["", Validators.compose([Validators.required])],
      zipCode:["", Validators.compose([Validators.required])],
      fromDate:["", Validators.compose([Validators.required])],
      toDate:["", Validators.compose([Validators.required])],
    });
    this.addJob =this.formBuilder.group({
      location:["", Validators.compose([Validators.required])],
      zipCode:["", Validators.compose([Validators.required])], 
      latitude:[""], 
      longitude:[""],
      state:[""],
      city:[""],
      country:[""], 
    });
    this.downloadForm =this.formBuilder.group({
      templateSample :["", Validators.compose([Validators.required])],
      templateFormate :["", Validators.compose([Validators.required])], 
    });
    
    this.minDate = new Date();
   }
  
   onDateChange(event: Date) {
  }

  ngOnInit(): void {
    this.currentDate = new Date()
    this.currentDate.setUTCHours(0,0,0,0);
    this.getCat()
    this.getUserDetail();
    this.getResumeDetail();
    this.getServices();
    this.getSkills();
    this.getEmpType();
    
    this.getJobPreference();
    this.getIndustry();
    this.getAllSecurityTravelRequirements(); 
    this.userSkillUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        if(value == ""){
          this.skillList = [];
        } else{
          let params = new HttpParams(); 
        params = params.append("search", value);
        this.api.getData(apiUrl._searchSkills,params)
              .subscribe(async (res) => {
                this.skillList = [];
                res.data.skills.map((skill) => {
                  let alreadyAdded = false;
                  this.addedSkills.map((addedSkills)=> {
                    if (addedSkills.id == skill.id) {
                      alreadyAdded = true;
                    }
                  })
                  if (!alreadyAdded) {
                    this.skillList.push(skill);
                  }
                  this.show=true;
                })
                
          })
        }
        
      });
      // jobs indus
      // this.userIndusUpdate.pipe(
      //   debounceTime(400),
      //   distinctUntilChanged())
      //   .subscribe(value => {
      //     if(value == ""){
      //       this.allIndustry = [];
      //     } else{
      //       let params = new HttpParams(); 
      //     params = params.append("search", value);
      //     this.api.getData(apiUrl._getAllIndutry,params)
      //           .subscribe(async (res) => {
      //             this.allIndustry = [];
      //             res.data.industry.map((indus) => {
      //               let alreadyAdded = false;
      //               this.addedIndus.map((addedIndus)=> {
      //                 if (addedIndus.id == indus.id) {
      //                   alreadyAdded = true;
      //                 }
      //               })
      //               if (!alreadyAdded) {
      //                 this.allIndustry.push(indus);
      //               }
      //               this.showIndus=true;
      //             })
                  
      //       })
      //     }
          
      //   });
      // jobs
      // this.jobQuesUpdate.pipe(
      //   debounceTime(400),
      //   distinctUntilChanged())
      //   .subscribe(value => {
      //     if(value == ""){
      //       this.allJobtitle = [];
      //     } else{
      //       let params = new HttpParams(); 
      //     params = params.append("search", value);
      //     this.api.getData(apiUrl._getAllIndutry,params)
      //           .subscribe(async (res) => {
      //             this.allJobtitle = [];
      //             res.data.jobtitle.map((jobs) => {
      //               let alreadyAdded = false;
      //               this.addedJobs.map((addedJob)=> {
      //                 if (addedJob.id == jobs.id) {
      //                   alreadyAdded = true;
      //                 }
      //               })
      //               if (!alreadyAdded) {
      //                 this.allJobtitle.push(jobs);
      //               }
      //               this.showJob=true;
      //             })
                  
      //       })
      //     }
          
      //   });
       
    this.dropdownSettingsMilitary = {
			singleSelection: true,
			idField: "id",
			textField: "fullName",
			itemsShowLimit: 1,
			allowSearchFilter: true,
      unSelectAllText: "Unselect All",
      searchPlaceholderText: "Type here to search",
      noDataLabel: 'No data available. It seems you have no access rights'
		}  

         this.dropdownSettingsIndustry = {
          singleSelection: false,
          idField: "id",
          textField: "name",
          itemsShowLimit: 2,
          allowSearchFilter: true,
          unSelectAllText: "Unselect All",
          enableCheckAll: false,
        };
        this.dropdownSettingJobTitle = {
          singleSelection: false,
          idField: "id",
          textField: "name",
          itemsShowLimit: 2,
          allowSearchFilter: true,
          unSelectAllText: "Unselect All",
          enableCheckAll: false,
          limitSelection:51
        };
    this.dropdownSettings = {
			singleSelection: false,
			idField: "id",
			textField: "name",
			itemsShowLimit: 2,
			allowSearchFilter: true,
      unSelectAllText: "Unselect All",
      enableCheckAll: false,
		};
    this.dropdownLanguageSettings = {
			singleSelection: true,
			idField: "name",
			textField: "name",
			itemsShowLimit: 1,
			allowSearchFilter: true,
      unSelectAllText: "Unselect All",
		};
  }
  ngAfterViewInit() {
    this.api.setSearch('');
  }
  
// category
getCat(){
  this.api.getDatas(apiUrl._jobcategories)
  .subscribe(async (res) => {
    this.allCat = res.data.data;
   })
} 
selectCategoryId(event){
  this.categoryId =event.target.value
  this.subCat=true; 
  this.allSubCat = []
  this.jobForm.patchValue({
    subCategoryId: []
  })
  this.api.loader(false)
  this.getSubCat()
}
// sub-category
getSubCat(){
  this.api.loader(false)
  let params = new HttpParams(); 
  params = params.append("categoryId", this.categoryId);
  this.api.getData(apiUrl._jobgetSubCategories,params)
  .subscribe(async (res) => { 
    this.allSubCat = res.data.data; 
    this.cdf.detectChanges()
  })
  this.cdf.detectChanges()
} 
  // ============ Multiple dropdown functionality =============
  
  getUserDetail(){
    this.api.getDatas(apiUrl._getUserInfo)
    .subscribe(async (res) => {
      this.userData = res.data;
      // console.log(this.userData,this.userData.gender==0?'Male':)
      this.profileImage = this.userData.profileImage 
      this.formVeteran.patchValue({
        militaryTitle :this.userData.militaryJobTitle
      }) 
     })
  }
  
  getIndustry(){
    this.api.getDatas(apiUrl._getAllIndutry)
    .subscribe(async (res) => {
      this.allIndustry = res.data.industry;
      this.allJobtitle = res.data.jobtitle; 
      
    if (this.selectedIndustriesDetails.length > 0){
      let IndustriesDetailsIds:any=[]; 
      this.allIndustry.map((industryid) => { 
        this.selectedIndustriesDetails.map((addedIndustry) => {
          if (industryid.id == addedIndustry.industryDetails.id) {
            IndustriesDetailsIds.push({name: addedIndustry.industryDetails.name, id: addedIndustry.industryDetails.id});
          }
        }) 
      }) 
      this.jobForm.patchValue({
        industryIds :IndustriesDetailsIds
      })
    }
    if (this.selectedJobTitleDetails.length > 0){
      let JobTitleDetailsIds:any=[]; 
      this.allJobtitle.map((jobTitleId) => { 
        this.selectedJobTitleDetails.map((addedJobTitle) => {
          if (jobTitleId.id == addedJobTitle.JobTitleDetails.id) {
            JobTitleDetailsIds.push({name: addedJobTitle.JobTitleDetails.name, id: addedJobTitle.JobTitleDetails.id});
          }
        }) 
      }) 
      this.jobForm.patchValue({
        jobTitleIds :JobTitleDetailsIds
      })
    }
     })
  }
   
  getAllSecurityTravelRequirements(){
    this.api.getDatas(apiUrl._getAllSecurityTravelRequirements)
    .subscribe(async (res) => {
      this.allTravel = res.data.travel;
      this.allSecurity = res.data.securityClearance;
     })
  }
  // selected Travel
  selectedTravel(i,event){ 
    if (this.allTravel[i]["selected"]) {
      this.allTravel[i]["selected"] = false
      event.srcElement.classList.remove("selected")
    } else {
      this.allTravel[i]["selected"] = true
      event.srcElement.classList.add("selected")
    }
    
  }
  // selected Security
selectedSecurity(i,event){ 
  if (this.allSecurity[i]["selected"]) {
    this.allSecurity[i]["selected"] = false
    event.srcElement.classList.remove("selected")
  } else {
    this.allSecurity[i]["selected"] = true
    event.srcElement.classList.add("selected")
  }
  
}
  getJobPreference(){
    this.api.getDatas(apiUrl._getJobPreference)
    .subscribe(async (res) => {
      this.allJobs = res.data; 
      this.allJobPreference = res.data?.getJobPreference[0]; 
      this.allTourOfDuties = res.data?.userTourOfDuties;  
      
     })
  }
  getResumeDetail(){
    this.api.getDatas(apiUrl._getResume)
    .subscribe(async (res) => {
      this.resumeData = res.data; 
      this.mediaInfo = [];
      this._albums = []; 
      for(let i =0; i<this.resumeData.projects.length; i++ ){ 
        let imageList : any = []
        if(this.resumeData.projects[i]?.projectDocumentsDetails != null || this.resumeData.projects[i]?.projectDocumentsDetails != ""){ 
        for (let j = 0; j < this.resumeData.projects[i]?.projectDocumentsDetails.length; j++) { 
          const src = this.globalUrl + this.resumeData.projects[i]?.projectDocumentsDetails[j].fileName; 
          const album = {
            src: src,
          };
          imageList.push(album); 
        }
      }
      this._albums.push(imageList); 
      
      }
      this.categoryId = this.resumeData?.categories[0]?.categoryId;
      this.getSubCat();
     })
  }
  open(index: number): void {
    // open lightbox 
    this._lightbox.open(this._albums, index);  
  }
  close(): void { // close lightbox programmatically 
    this._lightbox.close(); 
 }
    // smoth scroll
 public scrollToElement(element): void {
      element.scrollIntoView({
        behavior: "smooth", 
        block: "end", 
        inline: "nearest"
      });
 }
 
// project detail 
openProjectDetail(template: TemplateRef<any>) { 
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  
}
    // edit basic info 
opneProfileModel(userData,template: TemplateRef<any>) { 
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-md addModal" })
  );
  setTimeout(() => {
    this.form.patchValue(userData)
  }, 500);
}

// Veteran
opneVeteranModel(userData,template: TemplateRef<any>) { 
  let data=userData.id 
  this.title = "Edit";
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-md addModal" })
  );
  let serName:any=[];
  let serNameId;
  this.serviceList.map((ser)=>{
    if(ser.name == userData?.Services){ 
      serName.push(ser.id) 
      serNameId=ser.id;
    }
  })
  this.fileName=userData.authenticityDocumentLink,
  this.vetFileName=userData.veteranRelationDocumentLink,
  setTimeout(() => { 
    this.formVeteran.patchValue({
      authenticityDocumentLink:userData.authenticityDocumentLink,
      veteranRelationDocumentLink:userData.veteranRelationDocumentLink,
      veteranRelationName:userData.veteranRelationName,
      serviceId:serNameId,
      otherServiceTitle:userData.otherServiceTitle,
      militaryTitle:userData.militaryJobTitle,
    })
  }, 500);
}// get services
  
getServices(){ 
  this.api.showLoader = false;
  this.api.loader(false)
  this.api.getDatas(apiUrl._commonServices)
    .subscribe(async (res) => {
      this.serviceList=res.data.listing;
    }, err => {
        this.toastrService.error("Error", err.error.message)
  })
}

selectedService(event){
  this.selectedServiceId = event;
  this.serviceList.map((uni)=>{ 
    if(event == uni.id && uni.name == "Other"){
      this.showOtherService = true;
    } else{this.showOtherService= false}
  })
  this.getMosCode()
}
// getMosCode
getMosCode(){
  this.api.stopLoader();  
  let params = new HttpParams(); 
  params = params.append("serviceId", this.selectedServiceId); 
  this.api.getData(apiUrl._getMosListing,params)
  .subscribe(async (res) => {
    res.data.map((mos) => {
      mos["fullName"] = "(" + mos.mos + ") " + mos.name  + " - " + mos.rank
      if (this.userData && this.userData?.militaryJobTitle == mos.fullName) {
        this.formVeteran.patchValue({
          militaryTitle: [{fullName: mos["fullName"], name: mos["id"]}]
        }) 
      }
    })

    this.allMosCode = res.data;
   })
}
uploadDoc(event) {  
  if (event.target.files[0].size > 500000) {
    this.fileSize = true
    setTimeout(() => {
      this.fileSize = false
    }, 2000);
    return
  }
  if (event.target.files[0].type.includes("image") && (event.target.files[0].name.split(".")[1] != "png" && event.target.files[0].name.split(".")[1] != "svg") || event.target.files[0].type.includes("pdf")){
    const files = event.target.files; 
    this.fileUploadV = files[0];
    this.haveFileName =this.fileUploadV.name
    this.uploadFileToS3Doc();
  } else{
    this.showError= true
    setTimeout(() => {
      this.showError= false
    }, 2000);
    this.api.showErrorUpload("","Please upload only Jpg,Jpeg images & Pdf file")
  }
  
}

uploadFileToS3Doc() {
  const data = {
    "directory": "users/",
    "fileName": this.fileUploadV.name,
    "contentType": this.fileUploadV.type
  } 
  this.fileName=data.fileName;
  this.api.postData(apiUrl._upload, data)
    .subscribe(res => {
      this.http = new HttpClient(this.handler);
      this.http.put<any>(res.data.uploadURL, this.fileUploadV).subscribe(response => {
      this.haveFileName=res.data.fileName
      this.formVeteran.value.authenticityDocumentLink=res.data.fileName
      })
    })
}
// upload vetren dov

uploadVeteranDoc(event) { 
  if(event.target.files[0].size > 500000 ){
    this.fileSize =true
    setTimeout(() => {
      this.fileSize= false
    }, 2000);
  }
  if(event.target.files[0].type.includes("image") && (event.target.files[0].name.split(".")[1] !="png" && event.target.files[0].name.split(".")[1] !="svg")   || event.target.files[0].type.includes("pdf")){
    const files = event.target.files; 
    this.vetFileUpload = files[0];
    this.haveVeternFileName =this.vetFileUpload.name
    this.uploadVeternFileToS3();
  } else{
    this.showError= true
    setTimeout(() => {
      this.showError= false
    }, 2000);
    this.api.showErrorUpload("","Please upload only Jpg,Jpeg images & Pdf file")
  }
  
}
uploadVeternFileToS3() {
  const data = {
    "directory": this.globalUrl,
    "fileName": this.vetFileUpload.name,
    "contentType": this.vetFileUpload.type
  } 
  this.vetFileName=data.fileName;
  this.api.postData(apiUrl._upload, data)
    .subscribe(res => {
      this.http = new HttpClient(this.handler);
      this.http.put<any>(res.data.uploadURL, this.vetFileUpload).subscribe(response => {
      this.haveVeternFileName=res.data.fileName
      this.form.value.veteranRelationDocumentLink=res.data.fileName
      this.form.patchValue({
        veteranRelationDocumentLink:res.data.fileName
      })
      })
    })
}
changeAccept(event) { 
  this.isAccept = event.target.checked
  if (event.target.checked == "1") {  
    this.isAccept = true
  } 
}
onSubmitDoc(){ 
  if (this.fileName == null) {
    this.showError = true
    setTimeout(() => {
      this.showError = false
    }, 3000)
    return;
  } 
  
  if (!this.haveVeternFileName && this.userData?.userType == 1) {
    this.showError = true
    setTimeout(() => {
      this.showError = false
    }, 3000)
    return;
  } 
  if(this.formVeteran.value.honorAwardArray ==""){
    delete this.formVeteran.value.honorAwardArray;
  }
  if(this.showOtherService == true && this.formVeteran.value.otherServiceTitle == ""){
    this.showError= true;
    return
  } else{
    this.showError=false
  }
  
  if(this.formVeteran.value.militaryTitle != ""){
    this.formVeteran.patchValue({
      militaryJobTitleId :this.formVeteran.value.militaryTitle[0].id,
      militaryJobTitle :this.formVeteran.value.militaryTitle[0].fullName

    })
  }
  this.formVeteran.patchValue({
    authenticityDocumentLink:this.haveFileName,
    veteranRelationDocumentLink:this.haveVeternFileName,
    honorAwardArray:this.awardList,
    userType:this.userData.userType,
  })
  if (this.formVeteran.valid) {
   
    delete this.formVeteran.value.militaryTitle;
    this.api.putData(apiUrl._updateAuthDocumentV1, this.formVeteran.value)
      .subscribe(async (res) => {
        this.toastrService.success("Document Uploaded successfully!"); 
        this.getUserDetail();
        this.modalRef?.hide()
      })
  } else {
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 3000);
  }
} 
// skills
opneSkillModel(template: TemplateRef<any>) { 
  this.addedSkills=[]
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
opneEditSkillModel(template: TemplateRef<any>) { 
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
searchSkill() {
  this.userSkillUpdate.next(this.userSkill)
} 
dropSkill(){
  // this.show=false;
  this.show = !this.show;
} 
selectedSkill(i){
  this.show = !this.show;
  this.addedSkills.push(this.skillList[i])
  this.skillList.splice(i,1) 
}
removeSkills(i){
  this.addedSkills.splice(i,1)
  this.show = !this.show;
}

// selectedIndus(i){
//   this.addedIndus.push(this.allIndustry[i])
//   this.allIndustry.splice(i,1) 
// }
// selectedJobs(i){
//   this.addedJobs.push(this.allJobtitle[i])
//   this.allJobtitle.splice(i,1) 
// }
// removeIndus(i){
//   this.addedIndus.splice(i,1)
// }
// removeJob(i){
//   this.addedJobs.splice(i,1)
// }
// get skills
getSkills(){
  this.api.getDatas(apiUrl._getSkill)
  .subscribe(async (res) => {
    res.data.map((skill) => {
      this.addedSkills.push(skill.skillDetails);
    })
  })
}

onSubmitSkill(){
  let skillIds:any=[];
  this.addedSkills.map((skill)=>{
    skillIds.push({"skillId":skill.id,"otherTitle":skill.name})
  })
  this.skillform.patchValue({
    skillIdsArray: skillIds
  })

  this.show = !this.show;
  if(this.skillform.valid && this.addedSkills.length <= 50){
    this.api.putData(apiUrl._updateSkillV1, this.skillform.value)
    .subscribe(async (res) => {
      this.toastrService.success("", "Skills Added Successfully!");
      this.modalRef?.hide();
      this.getResumeDetail();
        this.skillform.reset();
    })
  } else{
    this.showError=true;
    setTimeout(() => {
      this.showError=false;
    }, 3000);
  }
  
}  
// volunterring
getEmpType(){
  this.api.getDatas(apiUrl._allEmpType)
  .subscribe(async (res) => {
    this.allEmployee = res.data.listing;
  })
}

 // selected employee
 onSelectedEmployment(i,event){
  this.allEmployee.map((emp)=>{
    emp["selected"] = false
    event.srcElement.classList.remove("selected")
    if(event.target.innerHTML){this.showContract=false;}
  })
  this.allEmployee[i]["selected"] = true
  event.srcElement.classList.add("selected")
  if(event.target.innerHTML == "Contractual"){this.showContract=true;} 
}

  // selected employee
  selectedEmployment(i,event){
    this.allEmployee.map((emp)=>{
      emp["selected"] = false
      event.srcElement.classList.remove("selected")
      if(event.target.innerHTML){this.showContract=false;}
    })
    this.allEmployee[i]["selected"] = true
    event.srcElement.classList.add("selected")
    if(event.target.innerHTML == "Contractual"){this.showContract=true;} 
  }

  // selected Employment Type Multiple
  selectedEmploymentType(i,event){ 
    if (this.allEmployee[i]["selected"]) {
      this.allEmployee[i]["selected"] = false
      event.srcElement.classList.remove("selected")
    } else {
      this.allEmployee[i]["selected"] = true
      event.srcElement.classList.add("selected")
    }
  }
  // selected workPlace List
  selectedworkPlaceList(i,event){ 
    if (this.workPlaceList[i]["selected"]) {
      this.workPlaceList[i]["selected"] = false
      event.srcElement.classList.remove("selected")
    } else {
      this.workPlaceList[i]["selected"] = true
      event.srcElement.classList.add("selected")
    }
  }

  // getJobCom
  getJobCom(){
    this.api.getDatas(apiUrl._allJobCom)
    .subscribe(async (res) => {
      this.allCompany = res.data.industry;
      this.allJob = res.data.jobtitle;
    })
  }
  
  // dateago
  dateAgo(fromDate:any,toDate:any) {
    if(fromDate != null && toDate != null){
      var startDate:any = new Date(fromDate);
      var endDate:any = new Date(toDate);
      var diffDate:any = new Date(endDate - startDate);
      return ((diffDate.toISOString().slice(0, 4) - 1970) + " years " + diffDate.getMonth() + " months ");
    }else {
      return "NA"
    }
  }
  // work exp model
openWorkModal(addMoreWork: TemplateRef<any>) { 
  this.workForm.reset()
  this.editId ="";
  this.title ="Add"
  this.workForm.controls["toDate"].enable();
  this.allEmployee.map((emp)=>{
    emp["selected"] = false;
    this.showContract=false;
  })
  this.modalRef = this.modalService.show(
    addMoreWork,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
editWork(work,addMoreWork: TemplateRef<any>){
  this.editId =work;
  this.title ="Edit"
  this.modalRef = this.modalService.show(
    addMoreWork,
    Object.assign({}, { class: "modal-lg addModal" })
  ); 
  setTimeout(() => {
    
    this.allEmployee.map((emp)=>{
      if(emp.id == work.employementTypeId){
        emp["selected"] = true 
      }
    })
    
    this.workForm.patchValue({
      ...work,
      fromDate:work.fromDate ? new Date(work.fromDate) : "",
      toDate: work.toDate ? new Date(work.toDate) : "",
    })
    if (work.isCurrentlyRole == 1) {
      this.workForm.controls["toDate"].disable();
    }
  }, 500);
}

// on submit
onWorkSubmit(){
  let employeeType = ""
    this.allEmployee.map((employee) => {
      if(employee["selected"] == true) {
        if (employeeType == "") {
          employeeType = employee.id
        } else {
          employeeType = employeeType + "," + employee.id
        }
      }
    })
    this.workForm.value.employementTypeId =employeeType;
    this.workForm.patchValue({
      employementTypeId:employeeType
    }) 
    if(this.workForm.value.underContractOf == ""){
      delete this.workForm.value.underContractOf;
    }
    if(this.workForm.valid){
      // let data = this.removeEmptyFiled(this.workForm)
      // data["isCurrentlyRole"] = this.workForm.value.isCurrentlyRole == true ? 1 : 0
      if(this.workForm.value.isCurrentlyRole == 1 || this.workForm.value.isCurrentlyRole == true){
        this.workForm.patchValue({
          isCurrentlyRole : 1
        })
      }
      if(this.editId){
        this.api.putData(apiUrl._updateWorkExp, this.removeEmptyFiled(this.workForm))
        .subscribe(async (res) => {
          this.toastrService.success("", "Work Experience Edited Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide();
        })
      } else{
        delete this.workForm.value.id
      this.api.postData(apiUrl._addWorkExp, this.removeEmptyFiled(this.workForm) )
      .subscribe(async (res) => {
        this.toastrService.success("", "Work Experience Added Successfully!");
        this.modalRef?.hide();
        this.getResumeDetail();
      })
    }
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 2500);
    }
}
// education model
openEduModal(addMoreEdu: TemplateRef<any>) { 
  this.getUniSpec();
  this.eduForm.reset();
  this.title ="Add"
  this.modalRef = this.modalService.show(
    addMoreEdu,
    Object.assign({}, { class: "modal-lg addModal" })
  );
} 
// getUniSpec
getUniSpec(){
  this.api.getDatas(apiUrl._allUniSpec)
  .subscribe(async (res) => {
    this.allSpec = res.data.specialization;
    this.allUni = res.data.universities;
  })
} 

selectedDegree(event){
  this.allSpec.map((deg)=>{
    if(event == deg.id && deg.name == "Other"){
      this.showOtherDegree = true;
    } else{
      this.showOtherDegree= false
    }
  })
}
selectedUniversity(event){
  this.allUni.map((uni)=>{
    if(event == uni.id && uni.name == "Other"){
      this.showOtherUniversity = true;
    } else{this.showOtherUniversity= false}
  })
}
  // edit
  editEdu(addMoreEdu: TemplateRef<any>,edu){
    this.getUniSpec();
    this.editId =edu.id;
    this.eduForm.reset();
    this.title ="Edit"
    this.modalRef = this.modalService.show(
      addMoreEdu,
      Object.assign({}, { class: "modal-lg addModal" })
    );
    setTimeout(() => {
      this.eduForm.patchValue({
        ...edu,
        fromDate:edu.fromDate ? new Date(edu.fromDate):"",
        toDate: edu.toDate ? new Date(edu.toDate) : "",
      })
      if (edu.isPursuing == 1) {
        this.eduForm.controls["toDate"].disable();
      }
    }, 500);
  } 
  
// on submit
onEduSubmit(){
  if(this.eduForm.value.isPursuing == 1 || this.eduForm.value.isPursuing == true){
    this.eduForm.patchValue({
      isPursuing : 1
    })
  }
  
  if(this.eduForm.value.gpa > 10 && this.eduForm.value.gpa >= 0){
    this.showGPAError= true;
    setTimeout(() => {
      this.showGPAError= false;
    }, 2500);
    return
  } else{
    this.showGPAError = false
  }
  if(this.eduForm.valid){
    if(this.editId){
      this.api.putData(apiUrl._updateEdu,  this.removeEmptyFiled(this.eduForm))
      .subscribe(async (res) => {
        this.toastrService.success("", "Education Added Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide();
        this.eduForm.reset();
      })
    } else{
      delete this.eduForm.value.id;
      this.api.postData(apiUrl._addEdu, this.removeEmptyFiled(this.eduForm))
      .subscribe(async (res) => {
        this.toastrService.success("", "Education Added Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide();
      })
    }
  } else{
    this.showError= true;
    setTimeout(() => {
      this.showError= false;
    }, 2500);
  }
  
}
  // volunteering
  openVolModal(template: TemplateRef<any>) {
    this.getEmpType()
    this.volForm.reset();
    this.volForm.controls["toDate"].enable();
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
  }
   // edit
   editVol(template: TemplateRef<any>,data){
    this.editId =data.id;
    this.title ="Edit"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
    setTimeout(() => {
      this.allEmployee.map((emp)=>{
        if(emp.id == data.employementTypeId){
          emp["selected"] = true 
        }
      })
       
      this.volForm.patchValue({
        ...data,
        fromDate:data.fromDate?new Date(data.fromDate) : "",
        toDate:data.toDate?new Date(data.toDate) : "",
      })
      if (data.isCurrentlyRole == 1) {
        this.volForm.controls["toDate"].disable();
      }
    }, 500);
  }
  // on submit
  onVolSubmit(){
    let employeeType = ""
    this.allEmployee.map((employee) => {
      if(employee["selected"] == true) {
        if (employeeType == "") {
          employeeType = employee.id
        } else {
          employeeType = employeeType + "," + employee.id
        }
      }
    })
    this.volForm.value.employementTypeId =employeeType;
    this.volForm.patchValue({
      employementTypeId:employeeType
    })
    if(this.volForm.value.isCurrentlyRole == 1 || this.volForm.value.isCurrentlyRole == true){
      this.volForm.patchValue({
        isCurrentlyRole : 1
      })
    }
    if(this.volForm.valid){
      if(this.editId){
        this.api.putData(apiUrl._updateVolExp, this.removeEmptyFiled(this.volForm))
          .subscribe(async (res) => {
            this.toastrService.success("", "Volunteer Experience Edit Successfully!");
            this.getResumeDetail();
            this.modalRef?.hide()
        })
      } else{
        delete this.volForm.value.id;
          this.api.postData(apiUrl._addVolExp, this.removeEmptyFiled(this.volForm))
          .subscribe(async (res) => {
            this.toastrService.success("", "Volunteer Experience Added Successfully!");
            this.getResumeDetail();
            this.modalRef?.hide()
        })
      }
      
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 2500);
    }
  }
  // projects
  openProjectModal(template: TemplateRef<any>) { 
    this.editId=""
    this.title="Add";
    this.projectForm.controls["toDate"].enable();
    this.projectForm.reset()
    this.addTeam.reset()
    this.awardList=[]
    this.thumbnailImage=[]
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
  } 
  openTeamModal(template: TemplateRef<any>) {
    this.addTeam.reset();
    this.editId=""
    this.title="Add";
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
  }
  
  closeModal(){
   this.modalService.hide();
   this.addTeam.reset();
   this.memberEditingPosition = -1;
  }
  closeAddModal(){
    this.projectForm.reset()
    this.modalService.hide();
   }
  
  // add team member
  onAddTeam(){
    this.title ="Add"
    if(this.addTeam.valid){
      let members = this.form.value.projectMembers;

      if (this.memberEditingPosition == -1) {
        if (members == null || members == "") {
          members = [];
        }
        members.push({
          name: this.addTeam.value.name,
          email: this.addTeam.value.email
        });
      } else {
        members[this.memberEditingPosition] = {
          name: this.addTeam.value.name,
          email: this.addTeam.value.email
        }
        this.memberEditingPosition = -1;
      }
    
      this.projectForm.patchValue({
        projectMembers: members
      }) 
      
      this.modalRef?.hide()
      this.addTeam.reset();
    } else{
      this.showTeamMemberError=true;
      setTimeout(() => {
        this.showTeamMemberError=false
      }, 3000);
    }
  }
  editMember(i,template: TemplateRef<any>){ 
    this.title="Edit";
    this.memberEditingPosition=i
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal centerAlign" })
    );
    setTimeout(() => {
      this.addTeam.patchValue(this.projectForm.value.projectMembers[i])
    }, 200);
  }
  deleteMember(i){
    let members = this.projectForm.value.projectMembers;
    members.splice(i,1)
    this.projectForm.patchValue({
      projectMembers: members
    })
  }
  // add awards
  addHonors(name){
    if(this.projectForm.controls.projectLinksTypeOf.valid){
    this.projectForm.patchValue({
      projectLinksTypeOf:""
    })
    
    if(name !== null && name.trim() != ""){
      var t = "https://www."; 
      var w = "www"; 
      if(name.toString() != "" && !name.toString().startsWith(t)&& !name.toString().startsWith(w)){
        name = t +name 
      } else if(name.toString() != "" && name.toString().startsWith(w)){  
        name = "https://" +name
      } 
      let containsLink = this.awardList.some((object) => 
      object.hasOwnProperty('link') && object['link'] === name ||
      object.hasOwnProperty('name') && object['name'] === name
    )
      if (!containsLink) {
        this.awardList.push({name, orderByIndex: this.awardList.length + 1});
      } else {
        this.showLinkSameError = true;
        setTimeout(() => {
          this.showLinkSameError = false;
        }, 2500);
          return
      }
    }

    
    let awardName : any = []
    this.awardList.map((awards) => {

      awardName.push(awards.link ? awards.link : awards.name);
    })
    this.projectForm.patchValue({
      projectLinks :awardName
    })
  } else{
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 2500);
    return
  }
  }
  deleteHonors(index) {
    this.awardList.splice(index, 1);
    let awardName : any = []
   this.awardList.map((awards) => { 
     awardName.push(awards.link ? awards.link : awards.name);
   })
   this.projectForm.patchValue({
     projectLinks :awardName
   })
  } 
  // image upload
  upload(event) { 
    const files = event.target.files; 
     this.fileUpload = files[0];
    this.uploadFileToS3();
  }
  
  uploadFileToS3() {
    const data = {
      "directory":ImageUrls.directories.users,
      "fileName": this.fileUpload.name,
      "contentType": this.fileUpload.type
    } 
    this.api.postData(apiUrl._upload, data)
      .subscribe(res => {
        this.http = new HttpClient(this.handler);
        this.http.put<any>(res.data.uploadURL, this.fileUpload).subscribe(response => {
         this.thumbnailImage.push({ name:this.fileUpload.name,fileName:res.data.fileName})
         this.projectForm.patchValue({
          projectMedia:this.thumbnailImage
         })
        })
      })
  } 
  // 
  deleteImage(i){
    this.thumbnailImage.splice(i,1);
    this.projectForm.patchValue({
      projectMedia:this.thumbnailImage
     })
  }
  // on submit
  onProjectSubmit(){ 
    if(this.projectForm.value.isCurrentlyOngoing == 1 || this.projectForm.value.isCurrentlyOngoing == true){
      this.projectForm.patchValue({
        isCurrentlyOngoing : 1
      })
    }
    if(this.projectForm.value.projectLinksTypeOf != ""){
      this.showErrorToAdd = true;
      setTimeout(() => {
        this.showErrorToAdd = false;        
      }, 3000);
      return
    }
    if(this.projectForm.valid){
      delete this.projectForm.value.projectLinksTypeOf;
      if(this.editId){
        this.api.putData(apiUrl._updateProjects, this.removeEmptyFiled(this.projectForm))
        .subscribe(async (res) => {
          this.toastrService.success("", "Education Added Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide();
        })
      } else{
        delete this.projectForm.value.id
        delete this.projectForm.value.projectLinksTypeOf;
        this.api.postData(apiUrl._addProjects, this.removeEmptyFiled(this.projectForm))
        .subscribe(async (res) => {
          this.toastrService.success("", "Projects Added Successfully!");
        this.modalService.hide();
        this.getResumeDetail()
      })
      }
      
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 2500);
    }
    
  } 
  editProject(project,template: TemplateRef<any>){
    this.editId =project.id;
    this.title ="Edit"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
   
    
    setTimeout(() => {
      this.awardList = project.projectLinksDetails
      this.thumbnailImage = project.projectDocumentsDetails
      let awardName : any = []
      project.projectLinksDetails.map((awards) => { 
        awardName.push(awards.link);
      }) 
      this.projectForm.patchValue({
        ...project,
        fromDate:project.fromDate ?  new Date(project.fromDate) : "",
        toDate: project.toDate ? new Date(project.toDate) : "",
        projectMembers:project.projectTeamMembersDetails,
        projectMedia: project.projectDocumentsDetails, 
        projectLinks: awardName,  
      })
      if (project.isCurrentlyOngoing == 1) {
        this.projectForm.controls["toDate"].disable();
      }
    }, 500);
  }
  // awards
  openAwardModal(template: TemplateRef<any>) { 
    this.awardform.reset();
    this.title ="Add"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
  }
  editAward(template: TemplateRef<any>,award){
    this.editId =award.id;
    this.title ="Edit"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
    setTimeout(() => {
      this.awardform.patchValue({
        ...award,
        issuesedOn:award.issuesedOn?new Date(award.issuesedOn) : ""
      })
    }, 500);
  }
  onAwardSubmit(){
    if(this.awardform.valid){
      if(this.editId){
        this.awardform.patchValue({
          id :this.editId
         })
        this.api.putData(apiUrl._updateAwards, this.removeEmptyFiled(this.awardform))
        .subscribe(async (res) => {
          this.toastrService.success("", "Awards & honors Upated Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide()
        })
      } else{
        delete this.awardform.value.id
        this.api.postData(apiUrl._addAwards, this.removeEmptyFiled(this.awardform))
        .subscribe(async (res) => {
          this.toastrService.success("", "Awards & honors Added Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide()
        })
      }
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 2500);
    }
    
  }
  //licence 
  openLicModel(template: TemplateRef<any>) {
    this.editId="" 
    this.licForm.reset()
    this.title ="Add"
    this.getEmpType()
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
  }
  editLic(data,template: TemplateRef<any>){
    this.editId =data.id;
    this.title ="Edit"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
    
    setTimeout(() => {
      this.licForm.patchValue({
        ...data,
        issuesedOn:data.issuesedOn ? new Date(data.issuesedOn) : "",
        expirydate:data.expirydate ? new Date(data.expirydate): "",
      })
    }, 100);
    
  }
  // on submit
  onLicSubmit(){ 
    
    if(this.licForm.value.credentialUrl != null){
      var t = "https://www."; 
      var w = "www"; 
      if(this.licForm.value.credentialUrl.toString() != "" && !this.licForm.value.credentialUrl.toString().startsWith(t)&& !this.licForm.value.credentialUrl.toString().startsWith(w)){
        this.licForm.patchValue({
          credentialUrl : t +this.licForm.value.credentialUrl
        })
      } else if(this.licForm.value.credentialUrl.toString() != "" && this.licForm.value.credentialUrl.toString().startsWith(w)){  
        this.licForm.patchValue({
          credentialUrl : "https://" +this.licForm.value.credentialUrl
        })
      } 
    } 
    if(this.licForm.valid){  
      if(this.editId){
        this.licForm.patchValue({
          id :this.editId
         })
        this.api.putData(apiUrl._updateLiences, this.removeEmptyFiled(this.licForm))
        .subscribe(async (res) => {
          this.toastrService.success("", "Licences Upated Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide()
        })
      } else{
        delete this.licForm.value.id
          this.api.postData(apiUrl._addLiences, this.removeEmptyFiled(this.licForm))
          .subscribe(async (res) => {
            this.toastrService.success("", "Licences Added Successfully!");
            this.modalRef?.hide();
            this.getResumeDetail();
          })
        }
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 2500);
    }
    
  }

  //language
  openLangModel(template: TemplateRef<any>,resumeData) { 
    this.editId ="";
    this.title ="Add"
    this.langForm.reset();
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
  }
  editLang(template: TemplateRef<any>,lang) {
    this.editId =lang.id;
    this.title ="Edit"  
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
    let patchFormValue = {
      ...lang,
      language: [{name: lang.language}]
    }
    this.langForm.patchValue(patchFormValue)
  }
  // on submit
  onLangSubmit(){  
    let langSet = new Set<string>();;
    for(let a=0; a < this.resumeData?.languages.length; a++) {
      langSet.add(this.resumeData?.languages[a].language)
    }
    if (langSet.has(this.langForm.controls['language'].value[0]['name'])) {
      this.langForm.controls['language'].setErrors({duplicate : true})
      this.showErrorSameLanguage = true;
      setTimeout(() => {
        this.showErrorSameLanguage = false;
      }, 3000);
      return;
    }
     
    if(this.langForm.valid){  
      let data = this.removeEmptyFiled(this.langForm);
      data['language'] = data['language'][0].name
      if(this.editId){
        this.api.putData(apiUrl._updateLanguage, data)
        .subscribe(async (res) => {
          this.toastrService.success("", "Language Upated Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide()
        })
      } else{
        this.api.postData(apiUrl._addLanguage,data)
        .subscribe(async (res) => {
          this.toastrService.success("", "Language Added Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide()
          this.langForm.reset();
        })
      }
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 2500);
    }
    
  }  
 
isDisabled(event:any){
  if(event.target.checked) {
    this.eduForm.controls["toDate"].disable();
  } else {
    this.eduForm.controls["toDate"].enable();
  }
  if(event.target.checked) {
    this.workForm.controls["toDate"].disable();
  } else {
    this.workForm.controls["toDate"].enable();
  }
}
   // === openJobModal ====
   openJobModal(job,template: TemplateRef<any>) {
    this.getIndustry()
    // this.jobForm.reset();
    this.addedIndus = [];
    this.addedJobs = [];
    this.editId =job.id;
    this.title ="Edit"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
    // this.allEmployee.map((emp)=>{
    //   if(emp.id == this.allJobPreference.employementTypeDetails?.id){
    //     emp["selected"] = true
    //   }
    // }) 
    this.allEmployee.map((e)=>{
      this.allJobPreference.employmentTypeMultipleDetail.map((x)=>{
        if(e.id == x.employmentTypeId){
          e["selected"] = true
        }
      })
    }) 
    let array=[]
    if(this.allJobPreference.workPlace!=''){
      array=this.allJobPreference.workPlace.split(',')
    }
    // console.log(array,this.allJobPreference.workPlace)
    this.workPlaceList.map((e)=>{
      array.map((x)=>{
        if(e.name == x){
          e["selected"] = true
        }
      })
    }) 
    this.allTravel.map((travel)=>{
      this.allJobPreference.jobPreferenceTravelRequirementsDetails.map((selectedTrav)=>{
        if(travel.id == selectedTrav.travelRequirementsDetails?.id){
          travel["selected"] = true
        }
      })
    }) 
    this.allSecurity.map((sec)=>{
      this.allJobPreference.jobPreferenceSecurityClearanceDetails.map((selectedSec)=>{
        if(sec.id == selectedSec.securityClearanceDetails?.id){
          sec["selected"] = true
        }
      })
    })

    this.selectedIndustriesDetails = this.allJobPreference.jobPreferenceIndustriesDetails;
    this.selectedJobTitleDetails = this.allJobPreference.jobPreferenceJobTitleDetails; 

    if (this.selectedIndustriesDetails.length > 0){
      let IndustriesDetailsIds:any=[]; 
      this.allIndustry.map((industryid) => { 
        this.selectedIndustriesDetails.map((addedIndustry) => {
          if (industryid.id == addedIndustry.industryDetails.id) {
            IndustriesDetailsIds.push({name: addedIndustry.industryDetails.name, id: addedIndustry.industryDetails.id});
          }
        }) 
      }) 
      this.jobForm.patchValue({
        industryIds :IndustriesDetailsIds
      })
    }
    if (this.selectedJobTitleDetails.length > 0){
      let JobTitleDetailsIds:any=[]; 
      this.allJobtitle.map((jobTitleId) => { 
        this.selectedJobTitleDetails.map((addedJobTitle) => {
          if (jobTitleId.id == addedJobTitle.JobTitleDetails.id) {
            JobTitleDetailsIds.push({name: addedJobTitle.JobTitleDetails.name, id: addedJobTitle.JobTitleDetails.id});
          }
        }) 
      }) 
      this.jobForm.patchValue({
        jobTitleIds :JobTitleDetailsIds
      })
    }
    let subCategoryIds:any=[]; 
    this.allSubCat.map((subcat) => {  
      job.subCategory.map((addedCat) => {
        if (subcat.id == addedCat.subCategoryId) {
          this.subCat = true;
          subCategoryIds.push({name: addedCat.jobPreferenceSubCategories.name, id: addedCat.subCategoryId});
        }
      }) 
    }) 
    this.minDate = new Date(this.allJobPreference.dateOfAvailability);
    this.jobForm.patchValue({
      ...this.allJobPreference,
      dateOfAvailability : this.allJobPreference.dateOfAvailability ? new Date(this.allJobPreference.dateOfAvailability) : "",
      securityClearance : this.allJobPreference.jobPreferenceSecurityClearanceDetails,
      locations : this.allJobPreference?.jobPreferenceLocationDetails,
      desiredSalary : this.allJobPreference.desiredSalary.toString(),
      categoryId : job?.categories[0]?.categoryId,
      subCategoryId :subCategoryIds,
      tourOfDuties: this.allJobPreference.userTourOfDuties,
      workAuthorization: this.allJobPreference.workAuthorization,
    })
    this.jobForm.markAsPristine();
    
  } 
  
// jobs prefer
openTourDuty(addTourDuty: TemplateRef<any>) { 
  this.title="Add";
  this.addTour.reset()
  this.tourEditingPosition = -1;
  this.modalRef = this.modalService.show(
    addTourDuty,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
// TourDuty
onTourDuty(){
  if(this.addTour.valid){
    let location = this.jobForm.value.tourOfDuties;
    if (this.tourEditingPosition == -1) {
      if (location == "" || location == undefined) {
        location = [];
      }
      location.push({
        location: this.addTour.value.location,
        zipCode: this.addTour.value.zipCode,
        fromDate: this.addTour.value.fromDate,
        toDate: this.addTour.value.toDate,
      });
    } else {
      location[this.tourEditingPosition] = {
        location: this.addTour.value.location,
        zipCode: this.addTour.value.zipCode,
        fromDate: this.addTour.value.fromDate,
        toDate: this.addTour.value.toDate,
      }
      this.tourEditingPosition = -1;
    }
  
    this.jobForm.patchValue({
      tourOfDuties: location
    }) 
    
    this.modalRef?.hide()
    this.addTour.reset();
  } else{
    this.showError=true;
    setTimeout(() => {
      this.showError=false
    }, 2000);
  }
}
editTour(i,template: TemplateRef<any>){
  this.title="Edit";
  this.tourEditingPosition=i
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  setTimeout(() => {
    this.addTour.patchValue(this.jobForm.value.tourOfDuties[i])
  }, 200);
}
deleteTour(i){
  let location:any=[];
  location = this.jobForm.value.tourOfDuties;
  location.splice(i,1)
  this.jobForm.patchValue({
    tourOfDuties: location
  })
}
// jobs prefer
openPreferredLocation(addJobs: TemplateRef<any>) { 
  this.addJob.reset();
  this.locationEditingPosition = -1;
  this.title="Add";
  this.modalRef = this.modalService.show(
    addJobs,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
editLocation(loc,i,template: TemplateRef<any>){ 
  this.title="Edit";
  let loca = this.jobForm.value.locations[i];
  this.locationEditingPosition=i
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  setTimeout(() => {
    this.addJob.patchValue(loca)
  }, 200);
}
deleteLocation(i){
  let location:any=[];
  location = this.jobForm.value.locations;
  location.splice(i,1)
  this.jobForm.patchValue({
    locations: location
  })
}
// add jobs
onAddJobs(){
  this.getLatLongFromZipCode(this.addJob.value.zipCode)
}
 // get current location 
 getLatLongFromZipCode(zipCode: string) {
  fetch("https://maps.googleapis.com/maps/api/geocode/json?address="+zipCode+ "&key=AIzaSyCDi96O9BAjbJUHBC-DTtw4QNmo3ekxIgA")
  .then(response => response.json())
  .then(data => {
    let state;
    let city;
    let country;
    for (let i = 0; i < data.results.length; i++){
      for (let j = 0; j < data.results[i].address_components.length; j++){
        if (data.results[i].address_components[j].types.includes("postal_code")) {
          zipCode = data.results[i].address_components[j].long_name;
        } else if (data.results[i].address_components[j].types.includes("administrative_area_level_1")) {
          state = data.results[i].address_components[j].long_name;
        }else if (data.results[i].address_components[j].types.includes("locality")) {
          city = data.results[i].address_components[j].long_name;
        }else if (data.results[i].address_components[j].types.includes("country")) {
          country = data.results[i].address_components[j].long_name;
        }
      }
    } 
    this.addJob.patchValue({
      location : data.results[0]?.formatted_address,
      state :state,
      city :city,
      country :country,
      latitude : data.results[0]?.geometry.location.lat.toString(),
      longitude : data.results[0]?.geometry.location.lng.toString(),
      zipCode : zipCode
    })
   
    this.addLocationToForm()
  })
}

addLocationToForm() {
  if(this.addJob.valid){
    let location = this.jobForm.value.locations;
   
    if (location == undefined) {
      location = []
    }
    if (this.locationEditingPosition == -1) {
      if (location == "") {
        location = [];
      }
      location.push({
        ...this.addJob.value, 
      });
      
    } else {
      location[this.locationEditingPosition] = {
        ...location[this.locationEditingPosition],
        ...this.addJob.value
      }
      this.locationEditingPosition = -1;
    }
    this.jobForm.patchValue({
      locations: location
    })
    this.modalRef?.hide()
    // this.addJob.reset();
    
  } else{
    this.showLocationError=true;
    setTimeout(() => {
      this.showLocationError=false
    }, 3000);
  }
  }
onJobSubmit(){ 
  if (!this.jobForm.controls.dateOfAvailability.pristine && this.jobForm.value.dateOfAvailability < new Date()) {
    this.showError= true;
    return
  } else{
    this.showError=false
  }
  
  if(this.jobForm.valid && this.jobForm.value.locations != "" && this.jobForm.value.jobTitleIds?.length <= 50){
  let employeeType = ""
  this.allEmployee.map((employee) => {
    if(employee["selected"] == true) {
      if (employeeType == "") {
        employeeType = employee.id
      } else {
        employeeType = employeeType + "," + employee.id
      }
    }
  }) 
  
  if(this.showOtherService == true && this.jobForm.value.otherServiceTitle == ""){
    this.showError= true;
    return
  } else{
    this.showError=false
  }
  this.jobForm.patchValue({
    // employementTypeId:employeeType,
    desiredSalary:this.jobForm.value.desiredSalary.toString(),
  }) 
  let empType:any=[]
  this.allEmployee.map((x) => {
    if(x["selected"] == true) {
      empType.push({"employmentTypeId":x.id,"name":x.name})
    }
  }) 
  this.jobForm.patchValue({
    employementType:empType
  })
  let travel:any=[]
  this.allTravel.map((tra) => {
    if(tra["selected"] == true) {
      travel.push({"travelRequirementId":tra.id,"otherTitle":tra.name})
    }
  }) 
  this.jobForm.patchValue({
    travelRequirement:travel
  }) 
  let security:any= []
  this.allSecurity.map((sec) => {
    if(sec["selected"] == true) {
      security.push({"securityClearanceId":sec.id,"otherTitle":sec.name})
    }
  }) 
  this.jobForm.patchValue({
    securityClearance:security
  })  
  let idustryIds: any = []
      this.jobForm.value.industryIds.map((indus)=>{
        idustryIds.push({"industryId":indus.id,"otherTitle":indus.name})
      })
       
      let jobIds: any = []
      this.jobForm.value.jobTitleIds.map((job)=>{
        jobIds.push({"jobTitleId":job.id,"otherTitle":job.name})
      })   
    let subCategory:any=[];
    this.jobForm.value.subCategoryId.map((subcat)=>{
      subCategory.push({"subCategoryId":subcat.id}); 
    })
    this.jobForm.patchValue({
      industryIds: idustryIds,
      jobTitleIds: jobIds,
      subCategoryId: subCategory,
    })
    let workPlaceType = ""
    this.workPlaceList.map((employee) => {
      if(employee["selected"] == true) {
        if (workPlaceType == "") {
          workPlaceType = employee.name
        } else {
          workPlaceType = workPlaceType + "," + employee.name
        }
      }
    })
    this.jobForm.value.workPlace =workPlaceType;
    
    // delete this.jobForm.value.industrySearch
    // delete this.jobForm.value.jobTitleSearch
    
    this.api.postData(apiUrl._addJobPreferenceV1, this.removeEmptyFiled(this.jobForm))
    .subscribe(async (res) => {
      this.modalRef?.hide();
      this.modalService?.hide();
      this.toastrService.success("", "Job Preferences Added Successfully!");
      this.getJobPreference();
      this.getResumeDetail()
    })
    this.closeModel();
  } else if(this.jobForm.value.locations == null){
    this.showLocError= true;
    setTimeout(() => {
      this.showLocError= false;
    }, 3000);
  }else{
    this.showError= true;
    this.showLocError= true;
    setTimeout(() => {
      this.showError= false;
      this.showLocError= false;
    }, 3000);
  }
}
   // === Modal ====
   openModal(template: TemplateRef<any>) { 
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-md addModal" })
    );
    this.getResumeSample()
  } 
 getResumeSample(){
  this.api.getDatas(apiUrl._downloadResumeSample).subscribe(
    res => {
      this.sampleList=res.data.listing;
    })
 }
  // submit from
  onSubmit(){
    this.form.value.countryCode= "+1"; 
    if(this.form.valid){
      this.api.putData(apiUrl._updateProfile, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.modalRef?.hide();
        this.getUserDetail(); 
        this.form.reset();
      })
    } else{
      this.showError=true;
      setTimeout(() => {
        this.showError=false;
      }, 3000);
    }
  }
   // check if only number
 preventNumbers(event): boolean { 
  event = (event) ? event : window.event;
  var charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
  }
  return true;
}
  //  remove
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }
  
    return formValues
  }

  onDownlaod() { 
    if(this.downloadForm.value.templateSample != ""){
      const data={
        templateFormate : "pdf",
        templateSample :this.downloadForm.value.templateSample.toString()
      } 
      this.api.postData(apiUrl._downloadResume, data).subscribe(
      pdf => {
        window.open(pdf.data.url);
        this.modalRef?.hide();
        // this.http.get(pdf.data.url, { responseType: "arraybuffer" }).subscribe(
        //   (pdf) => {
        //     console.log("downlading!...", pdf);
        //     const blob = new Blob([pdf], { type: "application/pdf" }); 
        //     const fileName = this.userData?.name +".pdf";
        //     // saveAs(blob, fileName);
           
        //     this.modalRef?.hide();
        //   },
        //   (err) => {
        //     console.log("err->", err);
        //   }
        // );    
      },
      err => {
        console.log("err->", err);
      }
    );
    } else{
      this.showTemplateError = true;
      setTimeout(() => {
        this.showTemplateError = false;
      }, 3000);
    }
  }
  closeDownload(){
    this.downloadForm.reset();
    this.modalRef?.hide();
  }
  closeModelLoc(){
    this.modalService?.hide();
    this.modalRef?.hide();
  }
  closeModel(){
    this.modalService?.hide();
    this.modalRef?.hide();
  }
  workShow(value){
    console.log(value)
    if(value!='' && value!=undefined && value!=null){
     return  value.replaceAll(',',', ')
    }
    return '-'
  }
}
